import './select.scss'
import InputWrapper from "../input-wrapper/input-wrapper"

export default (props) =>
    {
        const {
            error,
            displayError,
            message,
            helpertext,
            label,
            tooltip,
            required,
            remove,
            reset,
            add,
            onValueChange, 
            ...inputProps
          } = props;
          


        return (
            <InputWrapper error={error} disabled={props.disabled} displayError={displayError} message={message} label={label} helpertext={helpertext} inputType="select">
            <span className="group" >
            <select 
                id={props.id || props.name} 
                {...inputProps}
  
                >
                {props.placeholder && (
                    <option value="" disabled>{props.placeholder}</option>
                    )}                {props.options && props.options.map((option, i) =>
                   <option value={option.value} key={`${props.id || props.name}_${option.value}`} disabled={option.disabled}>
                        {option.label}
                    </option>
                )}
            </select>
            <span className="icon-control">
                <span className="icon medium"
                style={{
                    WebkitMaskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/chevron-updown.svg)',
                    maskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/chevron-updown.svg)',
                    color: 'currentColor'
                }}>
                </span>
            </span>
        </span>
            </InputWrapper>
        )
    }